export const TYPE_RELATIVE = 'relative';
export const TYPE_SENIOR = 'senior';

export const NO_IMAGE = 'none';
